import { APIAuthClient } from 'service/apicataleg/api/APIHttpClient';
import {
  CartCap,
  CreateClientCartRequest,
  OrderCreationResult,
} from 'service/apicataleg/types/ApiCatalegTypes';

const CartRepreService = {
  async createCart(request: CreateClientCartRequest): Promise<CartCap | null> {
    try {
      const { data } = await APIAuthClient.post('/representant/cart', request);
      return data;
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  //Obtenir les cistelles de l'usuari per aquest client -> repre o moderador
  async getClientCarts(idClient: number): Promise<Array<CartCap>> {
    try {
      const { data } = await APIAuthClient.get(`/representant/cart/cap/client/${idClient}/all`);
      return data;
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  async createOrder(idCart: number): Promise<OrderCreationResult> {
    return APIAuthClient.post<Array<number>>(`/representant/cart/${idCart}/order`)
      .then((res) => {
        return { error: false, message: '', npes: res.data };
      })
      .catch((error) => {
        return { error: true, message: error.response, npes: [] };
      });
  },
};

export default CartRepreService;
